import { Weekday } from './types';

export const AVAILABILITY_API_URL = 'availabilities';
export const AVAILABILITY_EXCEPTIONS_API_URL = 'availability-exceptions';
export const SEMESTER_BREAKS_API_URL = 'semester-breaks';
export const HOURS_REQUESTS_API_SEGMENT = 'hours-requests';

export const USE_AVAILABILITY_QUERY_KEY = 'availability';
export const USE_AVAILABILITY_EXCEPTIONS_QUERY_KEY = 'availabilityExceptions';
export const USE_SEMESTER_BREAKS_QUERY_KEY = 'semesterBreaks';

export const WEEKDAYS: Weekday[] = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY'
];

/** UI cap per day; the API allows up to 6. */
export const MAX_RANGES_PER_DAY = 3;

/** Server horizon: exceptions may be created up to this many weeks ahead. */
export const EXCEPTION_MAX_WEEKS_AHEAD = 26;

/** Server horizon for semester breaks (start date). */
export const SEMESTER_BREAK_MAX_WEEKS_AHEAD = 52;

export const NOTE_MAX_LENGTH = 255;

export const MINUTES_PER_DAY = 24 * 60;
export const MINUTES_PER_WEEK = 7 * MINUTES_PER_DAY;
